/**
 * Footer newsletter signup.
 *
 * Posts to the theme app proxy at /apps/api/subscribe and reports the result
 * in #newsletter-message.
 *
 * The previous version called the bare globals `hideMessage` / `showMessage`
 * from assets/notification.js, but that file was never added to the page, so
 * the very first statement in the submit handler threw
 *
 *     Uncaught (in promise) ReferenceError: hideMessage is not defined
 *
 * and the request was never sent. notification.js is now loaded ahead of this
 * file in sections/footer.liquid; the local fallbacks below keep the form
 * working even if it ever goes missing again.
 */
(function () {
  "use strict";

  var STATE_CLASSES = ["success", "error", "info", "warning"];
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function show(box, message, type) {
    if (typeof window.showMessage === "function") {
      window.showMessage(box, message, type);
      return;
    }
    if (!box) return;
    box.innerText = message == null ? "" : message;
    box.classList.remove.apply(box.classList, STATE_CLASSES);
    box.classList.remove("hidden");
    if (type) box.classList.add(type);
    box.style.display = "block";
  }

  function hide(box) {
    if (typeof window.hideMessage === "function") {
      window.hideMessage(box);
      return;
    }
    if (!box) return;
    box.innerText = "";
    box.classList.remove.apply(box.classList, STATE_CLASSES);
    box.style.display = "none";
  }

  function init() {
    var form = document.getElementById("newsletter-form");
    if (!form) return;

    var emailInput = document.getElementById("newsletter-email");
    var messageBox = document.getElementById("newsletter-message");
    var submitButton = form.querySelector('[type="submit"]');

    form.addEventListener("submit", async function (event) {
      event.preventDefault();
      hide(messageBox);

      var email = emailInput ? emailInput.value.trim() : "";

      // The form is novalidate, so the browser will not check this for us.
      if (!email) {
        show(messageBox, "Please enter your email address.", "error");
        if (emailInput) emailInput.focus();
        return;
      }

      if (!EMAIL_RE.test(email)) {
        show(messageBox, "Please enter a valid email address.", "error");
        if (emailInput) emailInput.focus();
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute("aria-busy", "true");
      }

      try {
        var response = await fetch("/apps/api/subscribe", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: email })
        });

        // The app proxy returns an HTML error page when it fails, so never
        // assume the body parses as JSON.
        var data = null;
        try {
          data = await response.json();
        } catch (parseError) {
          data = null;
        }

        if (data && data.success) {
          show(messageBox, data.message || "Thanks for subscribing!", "success");
          if (emailInput) emailInput.value = "";
        } else if (data && (data.error || data.message)) {
          show(messageBox, data.error || data.message, "error");
        } else if (!response.ok) {
          show(
            messageBox,
            "The subscription service is unavailable right now (" +
              response.status +
              "). Please try again later.",
            "error"
          );
        } else {
          show(
            messageBox,
            "We could not complete your subscription. Please try again.",
            "error"
          );
        }
      } catch (requestError) {
        show(
          messageBox,
          "Technical error occurred. Please try again later.",
          "error"
        );
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute("aria-busy");
        }
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
